<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :label="label"
    :search-input.sync="search"
    :loading="loading"
    :no-data-text="noDataText"
    :outlined="outlined"
    :dense="dense"
    :filter="filter"
    :item-text="itemText"
    :item-value="itemValue"
    :disabled="disabled"
    :rules="rules"
    return-object
    hide-details="auto"
  >
    <template v-slot:item="{ item }">
      <slot name="item" :item="item" />
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Object | null,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    searchFunction: {
      type: Function,
      required: true,
    },
    filter: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    timeoutDelay: {
      type: Number,
      default: 1000,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    noDataText: {
      type: String,
      default: "Nenhum resultado encontrado",
    },
    itemText: {
      type: String,
      default: "name",
    },
    itemValue: {
      type: String,
      default: "id",
    },
    noCompanyRefresh: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
      itemsIds: new Set(),
      search: "",
      timeout: null,
      loading: false,
    };
  },
  watch: {
    search(value) {
      if (!value) return;
      this.loading = true;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.performSearch(), this.timeoutDelay);
    },
    selectedCompany(value) {
      if (this.noCompanyRefresh) return;
      this.items = [];
      this.itemsIds = new Set();
      this.search = "";
      this.selected = null;
    },
  },
  methods: {
    async performSearch() {
      const items = await this.searchFunction(this.search.trim());
      items.forEach((item) => {
        if (this.itemsIds.has(item.id)) return;
        this.itemsIds.add(item.id);
        this.items.push(item);
      });
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
